import { Button, Table, Space, Modal } from 'antd';
import React,{useState} from 'react';
import { orderPurchaseQualityQrcode } from '../../api';

export default function Index(props) {
  const [open, setOpen] = useState(false);
  const handleOk = () => { setOpen(false); };
  const handleCancel = () => { setOpen(false); };
  const customer_feedback = props?.data;
  const columns = [
    {
      title: '质检单号',
      dataIndex: 'id',
    },
    {
      title: '质检柜号',
      dataIndex: 'bit_container_no',
    },
    {
      title: '提交时间',
      dataIndex: 'create_time',
    },
    {
      title: '质量反馈时间',
      dataIndex: 'customer_quality_time',
    },
    {
      title: '反馈来源',
      dataIndex: 'feedback_source',
    },
    {
      title: '操作',
      dataIndex: 'operation',
      render: (text, record) => <Button type='link' onClick={() => handDetail(record?.id)}>查看</Button>
    },
  ];
  const handDetail = (id) => {
    props.history.push(`/basic/user/order/CustomerQuality/${id}`);
  };
   const getOrderPurchaseAgainOrder = async () => {
    const { updateQualityQrcode = () => { }, order_no, quality_qrcode } = props;
    if (quality_qrcode) {
      setOpen(true);
    } else {
      const { data: { data: { quality_qrcode }, code } } = await orderPurchaseQualityQrcode({ order_no });
      if (+code === 0) {
        updateQualityQrcode(quality_qrcode);
        setOpen(true);
      }
    }
  };
  return (
    <>
      <div className='order-quality-container'>
        <div className='order-quality-item'>
          <div className='order-quality-item-top'>
            <Space className='order-quality-item-top-left'>
              <span>客户质量反馈</span>
            </Space>
            <div>
              <Button type='primary' onClick={() => getOrderPurchaseAgainOrder()}>创建质量反馈</Button>
            </div>
          </div>
          {(customer_feedback || []).length ?
            <Table
              className='order-quality-container-table'
              columns={columns} bordered dataSource={customer_feedback} pagination={false} rowKey={(record) => record.id}
              style={{ marginBottom: '20px' }}
            /> : null}
          {!customer_feedback.length ? <div className='c'>暂未提交质量反馈</div> : null}
        </div>
      </div>
      <Modal width={400} open={open} onOk={handleOk} onCancel={handleCancel} footer={null}  >
        <div style={{ textAlign: 'center' }}>
          <div>请用微信扫描下方小程序码，在手机端完成填写</div>
          <img style={{ margin: '20px auto', width: 200, height: 200 }} src={props.quality_qrcode} alt='' />
        </div>
      </Modal>
    </>
  );
}
